import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Table, Tag } from 'antd';
import { AppstoreOutlined } from '@ant-design/icons';

import { profileSelectors, fetchServices } from '../../../features/profile';

const statusColors = {
    'Выполнен': 'green',
    'Обработка': 'blue',
    'Ожидается оплата': 'orange',
    'На удержании': 'gold',
    'Отменён': 'red',
    'Возврат': 'volcano',
};

const ProfileServices = () => {
    const dispatch = useDispatch();

    const services = useSelector(profileSelectors.selectServices);
    const isLoading = useSelector(profileSelectors.selectServicesLoading);
    const pagination = useSelector(profileSelectors.selectServicesPagination);

    useEffect(() => {
        dispatch(fetchServices(1));
    }, [dispatch]);

    const handlePageChange = (page) => {
        dispatch(fetchServices(page));
    };

    const columns = [
        {
            title: 'Заказ',
            dataIndex: 'Заказ',
            key: 'order',
            render: (text) => <span style={{ fontWeight: 600 }}>{text}</span>,
        },
        {
            title: 'Дата',
            dataIndex: 'Дата',
            key: 'date',
        },
        {
            title: 'Статус',
            dataIndex: 'Статус',
            key: 'status',
            render: (text) => (
                <Tag color={statusColors[text] || 'default'}>{text}</Tag>
            ),
        },
        {
            title: 'Услуга',
            dataIndex: 'Услуга',
            key: 'service',
        },
    ];

    if (isLoading) {
        return (
            <div className="profile-orders-table services-skeleton">
                <div className="services-skeleton-header">
                    <div className="skeleton-shimmer" style={{ width: 60, height: 14 }} />
                    <div className="skeleton-shimmer" style={{ width: 40, height: 14 }} />
                    <div className="skeleton-shimmer" style={{ width: 56, height: 14 }} />
                    <div className="skeleton-shimmer" style={{ width: 56, height: 14 }} />
                </div>
                {[0, 1, 2, 3, 4].map((i) => (
                    <div
                        className="services-skeleton-row"
                        key={i}
                        style={{ animationDelay: `${i * 40}ms` }}
                    >
                        <div className="skeleton-shimmer" style={{ width: 72, height: 16 }} />
                        <div className="skeleton-shimmer" style={{ width: 80, height: 16 }} />
                        <div className="skeleton-shimmer" style={{ width: 90, height: 24, borderRadius: 4 }} />
                        <div className="skeleton-shimmer" style={{ width: '60%', height: 16 }} />
                    </div>
                ))}
            </div>
        );
    }

    if (!services || services.length === 0) {
        return (
            <div className="profile-empty-state">
                <AppstoreOutlined className="profile-empty-icon" />
                <p className="profile-empty-title">У вас пока нет услуг</p>
                <p className="profile-empty-description">Здесь будут отображаться ваши заказы услуг</p>
            </div>
        );
    }

    return (
        <div className="profile-orders-table">
            <Table
                columns={columns}
                dataSource={services}
                rowKey={(record) => record['Заказ']}
                pagination={{
                    current: pagination.page,
                    total: pagination.total,
                    pageSize: pagination.perPage,
                    showSizeChanger: false,
                    onChange: handlePageChange,
                }}
            />
        </div>
    );
};

export default ProfileServices;
